var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.9994V10.2494M12.5 10.2494L15.5 13.2494M12.5 10.2494L9.50001 13.2494M7.25001 19.9994C6.17944 20.0006 5.14353 19.62 4.32831 18.9261C3.51309 18.2322 2.97196 17.2704 2.80212 16.2134C2.63227 15.1563 2.84484 14.0734 3.40163 13.159C3.95842 12.2446 4.82297 11.5587 5.84001 11.2244C5.57871 9.8856 5.84877 8.49764 6.59299 7.35445C7.33722 6.21127 8.49718 5.40263 9.82723 5.09979C11.1573 4.79694 12.553 5.02367 13.7188 5.73195C14.8846 6.44023 15.7289 7.57446 16.073 8.89443C16.605 8.72141 17.1748 8.70059 17.718 8.83433C18.2612 8.96807 18.7562 9.25104 19.1471 9.65127C19.538 10.0515 19.8092 10.5531 19.93 11.0993C20.0509 11.6455 20.0166 12.2147 19.831 12.7424C20.6497 13.0551 21.333 13.6445 21.7626 14.4084C22.1921 15.1722 22.3407 16.0623 22.1826 16.9243C22.0245 17.7863 21.5697 18.5657 20.8971 19.1274C20.2244 19.6891 19.3763 19.9976 18.5 19.9994H7.25001Z",
    stroke: "#9A9AA7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.06f749db9037d5173b7deb3f0f3646f9.svg";
export { ForwardRef as ReactComponent };